@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
   /**
   * @prop --button-background-color: Button background color
   * @prop --button-background-color-hover: Button background color on hover
   * @prop --button-text-color: Button text color
   * @prop --button-text-color-hover: Button text color on hover
   * @prop --button-border-color: Button border color
   * @prop --button-border-color-hover: Button border color on hover
   * @prop --ping-z-index: Z-index of the component
   */
  --button-background-color: white;
  /* gray-100 */
  --button-background-color-hover: #f3f4f6;
  /* gray-900 */
  --button-text-color: #111827;
  /* blue-700 */
  --button-text-color-hover: #1d4ed8;
  /* gray-500 */
  --button-border-color: #6b7280;
  /* gray-700 */
  --button-border-color-hover: #374151;
  --ping-z-index: 50;

  display: block;
  z-index: var(--ping-z-index);
  position: fixed;
  right: 20px;
  bottom: 20px;
}

@layer components {
  .btn {
    @apply py-2.5 px-5 me-2 mb-2 text-sm font-medium focus:outline-none rounded-lg border;
    background-color: var(--button-background-color);
    color: var(--button-text-color);
    border-color: var(--button-border-color);
  }

  .btn:hover {
    background-color: var(--button-background-color-hover);
    color: var(--button-text-color-hover);
    border-color: var(--button-border-color-hover);
  }
}

.iframe-placeholder {
    /*loading-dots*/
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjQnIHZpZXdCb3g9JzAgMCAyNCAyNCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48c3R5bGU+LnNwaW5uZXJfcU04M3thbmltYXRpb246c3Bpbm5lcl84SFFHIDEuMDVzIGluZmluaXRlfS5zcGlubmVyX29YUHJ7YW5pbWF0aW9uLWRlbGF5Oi4xc30uc3Bpbm5lcl9aVExme2FuaW1hdGlvbi1kZWxheTouMnN9QGtleWZyYW1lcyBzcGlubmVyXzhIUUd7MCUsNTcuMTQle2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKDAuMzMsLjY2LC42NiwxKTt0cmFuc2Zvcm06dHJhbnNsYXRlKDApfTI4LjU3JXthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllcigwLjMzLDAsLjY2LC4zMyk7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoLTZweCl9MTAwJXt0cmFuc2Zvcm06dHJhbnNsYXRlKDApfX08L3N0eWxlPjxjaXJjbGUgY2xhc3M9J3NwaW5uZXJfcU04MycgY3g9JzQnIGN5PScxMicgcj0nMycvPjxjaXJjbGUgY2xhc3M9J3NwaW5uZXJfcU04MyBzcGlubmVyX29YUHInIGN4PScxMicgY3k9JzEyJyByPSczJy8+PGNpcmNsZSBjbGFzcz0nc3Bpbm5lcl9xTTgzIHNwaW5uZXJfWlRMZicgY3g9JzIwJyBjeT0nMTInIHI9JzMnLz48L3N2Zz4=);
  background-repeat: no-repeat;
  background-position: center;
}
